import { useQuery } from '@tanstack/react-query';
import { countriesApi } from '../api/countries.api';
import type { CountryHierarchy } from '../types/countries.types';
import { countryKeys } from './queryKeys';

export const useCountryHierarchy = (id: string, enabled = true) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: countryKeys.hierarchyDetail(id),
    queryFn: () => countriesApi.getCountryHierarchy(id),
    enabled: !!id && enabled,
    retry: true,
    staleTime: 0,
    refetchOnMount: true,
  });

  return {
    hierarchy: data?.data as CountryHierarchy | undefined,
    isLoading,
    refetch,
  };
};
